import { fetchGet } from '~utilities/fetch';

export async function solicitorsListRequest(): Promise<Response> {
    return fetchGet('/solicitors');
}
